// 退货详情
import React, { Component, Fragment } from 'react'

import { Table, message, List, Tag, Skeleton } from 'antd'

import { statusName } from './commo/common'

import { returnApply, getMerchantInfo, getReturnDetail } from '_src/api/api'

import LiItem from './commo/LiItem'

import './style/returnDetail.less'
import '../../common/style/common.less'

class ReturnDetail extends Component {
  constructor (props) {
    super(props)
    this.status = null
    this.state = {
      loading: true,
      dataList: [],
      serverList: [],
      merchantInfos: [],
      returnRefundForm: {
        amount: 0
      },
      returnAddressInfo: [],
      totalPrice: 0,
      param: {
        
      }
    }
  }
  componentDidMount () {
    this.loadData()
  }
  loadData () {
    const { id } = this.props 
    getReturnDetail(id)
      .then(res=>{
        console.log(res)
        this.setMerchantInfo()
        const { data } =res
        this.fliterData(data)
        this.getMerchant(data)
        this.getReturnAddress(data)
      })
      .catch(e=>{
        console.log(e)
      })
  }

  // 获取基础信息
  fliterData (data) {
    const { order, user } = data
    /**
     * 我不知道为什么有个order,我不想知道也懒得再问
     */
    // const { order } = orderGoods
    // 订单编号
    const { orderSn, orderGoods } = order
    let totalPrice = 0
    const goodInfo = orderGoods.map(item => {
      let { goodsSpecification, price, number } = item
      price = (price/100).toFixed(2)
      /**
     * goodsSpecification 退货商品信息集合
     * price 退货商品价格，什么鬼，价格怎么跑到这里来
     * number 退货商品数量，什么鬼，数量怎么跑到这里来
     */
      const { goods, specificationsName } = goodsSpecification
      const {goodsName, picUrl, unit} = goods
      totalPrice += price*number
      return { key: 'fuck', picUrl, goodsName, price, specificationsName, number: `${number} ${unit}` }
    })
    

    /**
     * 服务单信息 
     * serviceNum   服务单号
     * status       状态
     * createAt     申请时间
     * contacts     联系人
     * contactPhone 联系电话
     * returnCause  退货原因
     * problemDesc  问题描述
     * voucherUrls  凭证照片
     */
    const {serviceNum, status, createAt, contacts, contactPhone, returnCause, problemDesc, voucherUrls} = data
    this.status = status
    const { mobile } = user
    const imgArr = JSON.parse(voucherUrls)
    const serverInfo = [
      {title: '服务单号', content: serviceNum},
      {title: '申请状态', content: <Tag color={statusName(status).color}>{statusName(status).text}</Tag>},
      {title: '订单编号', content: orderSn},
      {title: '申请时间', content: createAt},
      {title: '用户账号', content: mobile},
      {title: '联系人', content: contacts},
      {title: '联系电话', content: contactPhone},
      {title: '退货原因', content: returnCause.causeType},
      {title: '问题描述', content: problemDesc},
      {title: '凭证照片', content: imgArr}
    ]
    // const totalPrice = price*number
    this.setState((preState)=>({
      loading: false,
      dataList: goodInfo,
      serverList: serverInfo,
      totalPrice,
      returnRefundForm: {...preState.returnRefundForm, amount: totalPrice}      
    }))
    
    // const goodInfo = {...{ goodsName } = goods}
  }

  // 处理人
  getMerchant (data) {
    const { returnProcess } = data
    /**
     * remark处理备注
     * merchant商家集合
     * createAt处理时间
     */
  
    const merchantInfos = returnProcess.map(item=>{
      const { remark, merchant, createAt } = item
      const { storeName } = merchant
      return [
        {title: '处理人', content: storeName},
        {title: '处理时间', content: createAt},
        {title: '处理备注', content: remark},
      ]
    })
    
    this.setState(()=>({
      merchantInfos
    }))
  }

  // 获取收货人地址
  getReturnAddress (data) {
    const { orderGoods } = data
    const { price, number } = orderGoods
    const { returnAddress } =data
    const {name, province, city, county, addressDetail, tel, amount } = returnAddress
    const returnAddressInfo = [
      {title: '订单金额', content: price*number},
      {title: '申请退款金额', content: amount},
      {title: '收货人姓名', content: name},
      {title: '收货地址', content: `${province}${city}${county}${addressDetail}`},
      {title: '联系电话', content: tel},
    ]
    this.setState(()=>({
      returnAddressInfo
    }))
  }

  setMerchantInfo () {
    getMerchantInfo()
      .then(res=>{
        const { data } = res
        const { storeName, mobile, returnAddress } = data
        this.setState((preState)=>({
          returnRefundForm: {...preState.returnRefundForm, name: storeName, tel: mobile, addressDetail: returnAddress}
        }))
      })
  }

  columns = () => ([
    {
      title: '商品图片',
      dataIndex: 'picUrl',
      render: (item) => {
        return (<img style = {{width: 100}} src = {item} alt = '' />)
      },
    },
    {
      title: '商品名称',
      dataIndex: 'goodsName',
    },
    // {
    //   title: '价格',
    //   dataIndex: 'price',
    // },
    {
      title: '规格',
      dataIndex: 'specificationsName',
    },
    {
      title: '数量',
      dataIndex: 'number',
    },
    {
      title: '价格(元)',
      dataIndex: 'price',
    },
  ])
  handleNumberChange (key, value) {
    this.setState((preState)=>({
      returnRefundForm: {...preState.returnRefundForm, [key]: value}
    }))
  }
  handleTextChange (key, e) {
    const { target } = e
    const value = target.value
    this.setState((preState)=>({
      param: {...preState.param, [key]: value}
    }))
  }
  handleSubmit = (status) => {
    message.error('错误提示')
    const { id } = this.props 
    
    let { param, returnRefundForm } = this.state
    const { remark } = param
    param = {remark, returnRefundForm}
    returnApply(id, status, param)
  }
  render () {
    const { dataList, totalPrice, serverList, merchantInfos, returnAddressInfo, loading } = this.state
    return (
      <Fragment>
        {
          loading
            ?<div className = "skeleton_bar">
              <Skeleton loading = {false} active />
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </div>:null
        }
        
        <div className = "ReturnDetail">
        
          {/* <div className = "page_top">
            <p className = "page_top_title">服务详情-待处理</p>
            <div className = "returnDetail_btn">
              <Button className = "" type="primary" onClick = {()=>{ this.props.history.goBack() }}>
                <Icon type="left" />
            返回
              </Button>
            </div>
          </div> */}
          <div className = "page_content">
            <Table
              size = "middle"
              columns={this.columns()}
              dataSource={dataList}
              bordered
              title={() => '退货商品'}
              footer={() => (<TableFooter text = {totalPrice} />)}
              pagination = {false}
            />
            <div style = {{marginTop: 20}}>
              <List
                header={<div>服务详情</div>}
                bordered
                dataSource={serverList}
                renderItem={item => (
                  <List.Item style = {{padding: 0}}>
                    <LiItem Item = {item} />
                  </List.Item>
                )}
              >   
                {/* <List.Item>
                '气死'
                </List.Item> */}
              </List>
      
            </div>

            {merchantInfos.map((item, index) => {
              return (
                <div key = {index} style = {{marginTop: 20}}>    
                  <List
                    bordered
                    dataSource={item}
                    renderItem={item => (
                      <List.Item style = {{padding: 0}}>
                        <LiItem Item = {item} />
                      </List.Item>
                    )}
                  />
                </div>
              ) })}
        
          
            {!!returnAddressInfo.length &&<div style = {{marginTop: 20}}>
              <List
                bordered
                dataSource={returnAddressInfo}
                renderItem={item => (
                  <List.Item style = {{padding: 0}}>
                    <LiItem Item = {item} />
                  </List.Item>
                )}
              />  
            </div>}
            {this.props.children}
          </div>
        </div>
      </Fragment>
    )
  }
}

const TableFooter = (props) =>{
  return (
    <div>
      <p style = {{textAlign: 'right', padding: 0, margin: 0}}>
          总计：<strong style = {{color: 'red'}}>{props.text}元</strong>
      </p>
    </div>
  )
}


export default ReturnDetail